import Vue from 'vue';
import { apiPath } from '../constants';

const Insight = Vue.resource(
  `${apiPath}/insight{/packageName}{/get}/`,
  {},
  {
    getFilters: { method: 'GET', params: { get: 'config' } },
    getStats: { method: 'GET', params: { get: 'stats' } },
    getCsv: { method: 'GET', params: { get: 'stats', export_type: 'csv' } },
    getDashboard: {
      method: 'GET',
      params: { get: 'stats', stat_type: 'dashboard', child: 'dashboard' },
    },
    getEvents: {
      method: 'GET',
      params: { get: 'events' },
    },
  },
);

export default Insight;
